WiseMetering.Model.ExternalAsset = WiseMetering.Model.extend({});
